import React, { Component, Fragment, useState } from "react";
import { useParams } from 'react-router-dom';
import { withStyles, createStyles } from "@mui/styles";
import CustomizedSnackbar from "../../../../components/CustomizedSnackbar/CustomizedSnackbar";
import LoginMenu from "../../../../components/LoginMenu/LoginMenu";
import {
  Divider,
  IconButton,
  Tooltip,
  CircularProgress,
  Grid,
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import SectionContent from "./Chunks/SectionContent";

const styles = (theme) =>
  createStyles({
    tabsPanel: {
      flexGrow: 1,
      //backgroundColor: theme.palette.background.paper,
      display: "flex",
      minHeight: 220,
      height: window.innerHeight - 240,
      width: "100%",
    },
    tabs: {
      //borderRight: `1px solid ${theme.palette.divider}`,
      borderRight: `1px solid rgb(58, 127, 187, 0.3)`,
      backgroundColor: "#f6f8fa",
      border: "1px solid #e1e4e8",
      minWidth: 200,
    },
  });

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
      style={{ width: "100%" }}
    >
      {value === index && (
        <Box p={1} style={{ alignItems: "center" }}>
          {children}
        </Box>
      )}
    </div>
  );
}

class CourseHomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      recordId: this.props.params.courseId || "Course",
      courseLabel: localStorage.getItem("selectedCourseLabel") || "Course",
      isLoading: false,
      isLoginMenu: false,
      isReload: false,
      isOpenSnackbar: false,
      snackbarMessage: "",
      snackbarSeverity: "",
      tabIndex: 0,
    };
  }

  handleOpenSnackbar = (msg, severity) => {
    this.setState({
      isOpenSnackbar: true,
      snackbarMessage: msg,
      snackbarSeverity: severity,
    });
  };

  handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({
      isOpenSnackbar: false,
    });
  };

  handleFileChange = (event) => {
    const { files = [] } = event.target;
    if (files.length == 1) {
      if (
        (files[0].type === "application/pdf" ||
          files[0].type === "application/msword" ||
          files[0].type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document") &&
        files[0].size / 1000 < 10000
      ) {
        this.setState({
          files,
          filesError: "",
        });
      } else {
        this.handleOpenSnackbar(
          "Please select only pdf, doc or docx file with size less than 10 MBs.",
          "error"
        );
      }
    } else {
      this.handleOpenSnackbar(
        "Please select only one file at a time.",
        "error"
      );
    }
  };

  onClearFilters = () => {
    this.setState({
      studentName: "",
      genderId: 0,
      degreeId: 0,
      applicationId: "",
      eventDate: null,
    });
  };

  handleDateChange = (date) => {
    this.setState({ eventDate: date });
  };

  onHandleChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  handleToggleTableFilter = () => {
    this.setState({ showTableFilter: !this.state.showTableFilter });
  };

  handleToggleSearchBar = () => {
    this.setState({ showSearchBar: !this.state.showSearchBar });
  };

  isFileValid = () => {
    let isValid = true;
    if (this.state.files.length < 1 && this.state.recordId == 0) {
      this.handleOpenSnackbar("Please select file.", "error");
      isValid = false;
    } else {
      this.setState({ filesError: "" });
    }
    return isValid;
  };

  handleClickOpen = (popupBoxFiles) => {
    this.setState({
      popupBoxOpen: true,
      popupBoxFiles: popupBoxFiles,
    });
  };

  handleClose = () => {
    this.setState({
      popupBoxOpen: false,
      popupBoxFiles: [],
    });
  };

  a11yProps = (index) => {
    return {
      id: `vertical-tab-${index}`,
      "aria-controls": `vertical-tabpanel-${index}`,
    };
  };

  handleChangeTab = (event, newValue) => {
    this.setState({ tabIndex: newValue });
  };

  componentDidMount() {
    const data = this.props.params.courseId;
    console.log(data, "data is coming");
    this.props.setDrawerOpen(false);
  }

  render() {
    const { classes } = this.props;

    return (
      <Fragment>
        <LoginMenu
          reload={this.state.isReload}
          open={this.state.isLoginMenu}
          handleClose={() => this.setState({ isLoginMenu: false })}
        />
        <div
          style={{
            padding: 20,
          }}
        >
          <Grid container justifyContent="space-between">
            <Typography
              style={{
                color: "#1d5f98",
                fontWeight: 600,
                textTransform: "capitalize",
              }}
              variant="h5"
            >
              {/* 
              <Tooltip title="Back">
                <IconButton onClick={() => window.history.back()}>
                  <ArrowBackIcon fontSize="small" color="primary" />
                </IconButton>
              </Tooltip>  
              */}
              {this.state.courseLabel || "Course Home Page"}
            </Typography>
          </Grid>
          <Divider
            style={{
              backgroundColor: "rgb(58, 127, 187)",
              opacity: "0.3",
            }}
          />
          <br />
          <Grid size={12}>
            <Tooltip title="Class Discussion">
              <Button
                variant="outlined"
                color="primary"
                onClick={() => window.open("#/dashboard/F111Form/0")}
              >
                <ForumOutlinedIcon color="primary" />
              </Button>
            </Tooltip>
          </Grid>
          <br />
          <Divider
            style={{
              backgroundColor: "rgb(58, 127, 187)",
              opacity: "0.3",
            }}
          />
          <Grid size={12}>
            <div className={classes.tabsPanel}>
              <Tabs
                name="tabIndex"
                orientation="vertical"
                variant="scrollable"
                value={this.state.tabIndex}
                onChange={this.handleChangeTab}
                aria-label="Vertical tabs"
                className={classes.tabs}
                indicatorColor="primary"
                alignItems="center"
              >
                {/* <Tab label={<Typography color="primary" variant="button">Section Content</Typography>} {...this.a11yProps(0)} /> */}
                <Tab
                  label={
                    <Button
                      variant="contained"
                      color="primary"
                      style={{ width: "100%" }}
                    >
                      Section Content
                    </Button>
                  }
                  {...this.a11yProps(0)}
                />
                {/* <Tab label={<Button variant="contained" color="primary" style={{width:"100%"}}>Class Discussion</Button>} {...this.a11yProps(0)} /> */}
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => window.open("#/dashboard/F111Form/0")}
                  style={{ width: "89%", margin: "auto", opacity: 0.5 }}
                >
                  Class Discussion
                </Button>
              </Tabs>
              <TabPanel value={this.state.tabIndex} index={0} >
                <SectionContent courseId={this.state.recordId} />
              </TabPanel>
              <TabPanel value={this.state.tabIndex} index={1}>
                <Typography color="error" variant="h3">
                  <br />
                  Soon
                </Typography>
              </TabPanel>
            </div>
          </Grid>
          <CustomizedSnackbar
            isOpen={this.state.isOpenSnackbar}
            message={this.state.snackbarMessage}
            severity={this.state.snackbarSeverity}
            handleCloseSnackbar={() => this.handleCloseSnackbar()}
          />
        </div>
      </Fragment>
    );
  }
}

// HOC to inject useParams into class component
function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let params = useParams();
    return <Component {...props} params={params} />;
  }
  return ComponentWithRouterProp;
}

export default withRouter(withStyles(styles)(CourseHomePage));
